import { Component, OnInit } from '@angular/core';
import { CompanyService } from 'app/shared/services/company.service';
import { Company } from 'app/shared/models/company';
import { AuthService } from 'app/login/services/auth.service';
import { AlertService } from 'app/shared/services/alert.service';

@Component({
  selector: 'dac-account-owner-settings',
  templateUrl: './account-owner-settings.component.html',
  styleUrls: ['./account-owner-settings.component.scss']
})
export class AccountOwnerSettingsComponent implements OnInit {

  public isSaving:boolean;
  public loaded:boolean;
  private _company:Company;

  constructor(private companyService:CompanyService, private authService:AuthService, private alertService:AlertService) { }

  ngOnInit() {
    this.loaded = false;
    this.authService.getCurrentUser().then(user => {
      this.companyService.getAccountOwnerCompany(user.companyID).then(c => {
        this.loaded = true;
        this._company = c;
      })
      .catch(e => {
        this.alertService.error("Failed to get company settings.  Check your internet connection and try again");
        console.error(e);
      });
    }).catch(error => {
      console.error(error);
      this.alertService.error("Failed to retrieve account settings.  Check your internet connection and try again");
    });
  }

  public save() {
    this.isSaving = true;
    this.companyService.saveAccountOwnerCompany(this._company).then(result => {
      this._company = result;
      this.isSaving = false;
      this.alertService.success("Company settings saved!");
    })
    .catch(e => {
      this.alertService.error("Failed to save company settings.  Check your internet connection and try again.");
      console.error(e);
      this.isSaving = false;
    });
  }

  public get Company() {
    return this._company;
  }

}



// WEBPACK FOOTER //
// ./src/app/account-owner-settings/account-owner-settings.component.ts